import { FieldDescription, FieldError, FieldLabel, fieldIds, fieldInputClass } from './shared';
import type { FieldProps } from './FieldProps';

export function SelectField({ field, value, error, onChange }: FieldProps) {
  const { inputId, descriptionId, errorId } = fieldIds(field.path);
  const options = (field.schema.enum ?? []).map(String);
  const describedBy = [field.schema.description ? descriptionId : null, error ? errorId : null]
    .filter(Boolean)
    .join(' ');

  return (
    <div>
      <FieldLabel htmlFor={inputId} required={field.required}>
        {field.schema.title ?? field.key}
      </FieldLabel>
      <FieldDescription id={descriptionId} text={field.schema.description} />
      <select
        id={inputId}
        className={fieldInputClass}
        value={typeof value === 'string' ? value : ''}
        onChange={(event) => onChange(event.target.value || undefined)}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy || undefined}
      >
        <option value="" />
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
      <FieldError id={errorId} message={error} />
    </div>
  );
}
